import type { FC } from "react";
import { Navigate, useLocation } from "react-router";

export const LinkRedirect: FC = () => {
  const { pathname, search, hash } = useLocation();
  const to = pathname.substring("/link".length) + search + hash;
  return <Navigate to={to} replace />;
};
